<template>
  <v-container fluid :class="currentEvent == null ? 'fill-height' : ''">
    <v-row v-if="loading">
      <v-col>
        <Loading/>
      </v-col>
    </v-row>
    <v-row align="center" v-else justify="center" class="mx-0"><v-col cols="12">
      <v-breadcrumbs :items="breadCrumbItems" large>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
              :disabled="item.disabled"
              :class="[
                'text-capitalize px-0',
                {
                  'cursor-pointer':
                    item.routeName != $route.name && !item.disabled,
                },
              ]"
              @click="handleRoute(item)"
          >
            <div
                :class="[
                  item.routeName != $route.name && !item.disabled
                    ? 'primary--text'
                    : 'grey--text',
                  'text-subtitle ',
                ]"
            >
              {{ item.text }}
            </div>
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-col>
      <v-col cols="12">
        <v-card outlined min-height="110vh" class="px-8 py-4">
          <v-card-title>
            <UserAvatar
                :usersInitials="nameInitials"
                :displayImageUrl="this.displayImageUrl"
                :size="70"
            />
            <v-col>
              {{ fullName }}
              <p v-if="currentAttendee.ticketType">{{ currentAttendee.ticketType }}</p>
              <p style="color: #96A4B9; font-size: 14px">{{invitationStatus}}</p>
            </v-col>
          </v-card-title>
          <template>
            <v-tabs v-model="tab"
                    active-class="primary--text"
            >
              <v-tab active-class="primary--text" class="text-capitalize" v-for="item in items" :key="item.tab">
                {{ item.text }}
              </v-tab>
            </v-tabs>
            <v-divider/>
            <v-card-title class="px-0 text--black">
              General Information
            </v-card-title>
            <v-data-table
                :headers="generalInformationHeaders"
                :items="[generalInformation]"
                disable-sort
                hide-default-footer/>
            <div v-if="this.currentAttendee && this.currentAttendee.selfCategories && Object.keys(this.currentAttendee.selfCategories).length">
              <v-divider class="my-4" />
              <v-card-title class="px-0 text--black">
                Category that best describes you
              </v-card-title>
              <v-data-table
                  :headers="categoryHeaders"
                  :items="getSelfCategory"
                  hide-default-footer/>
            </div>
            <div v-if="this.currentAttendee && this.currentAttendee.preferredCategories && Object.entries(this.currentAttendee.preferredCategories).length">
            <v-divider class="my-4"/>
            <v-card-title class="px-0 text--black">
              Who would you like to meet at the event?
            </v-card-title>
            <v-data-table
                :headers="categoryHeaders"
                :items="getPreferredCategory"
                hide-default-footer/>
            </div>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
 import Loading from "@/components/Loading.vue";
 import {mapActions, mapGetters} from "vuex";
 import Attendee from "@/models/Attendee";
 import {onSnapshot} from "firebase/firestore";
 import {businessCardsDocRef, eventAttendeesDocRef} from "@/shared/firebase_utils";
 import UserAvatar from "@/components/UserAvatar.vue";

 export default {
   name: "EditAttendee",
   components: {
     UserAvatar,
     Loading
   },
   computed: {
     ...mapGetters(["currentEvent"]),
     breadCrumbItems() {
       if (this.currentEvent && this.currentAttendee) {
         let items = [
           {
             text: "EventConnect",
             disabled: false,
             routeName: "MultiConnect",
             params: "",
           },
           {
             text: this.currentEvent.name,
             disabled: false,
             routeName: "editMultiConnect",
             params: {eventId: this.currentEvent.id},
             query: {tab: 3}
           },
           {
             text: this.fullName,
             disabled: true,
             routeName: "editAttendeeDetails",
             params: {
               eventId: this.currentEvent.id,
               attendeeId: this.currentAttendee.attendeeId,
             },
           },
         ];
         return items;
       } else return [];
     },
     fullName() {
       if (this.attendeeBusinessCard) {
          return this.attendeeBusinessCard.firstName + ' ' + this.attendeeBusinessCard.lastName;
       }
       if (this.currentAttendee) {
         return this.currentAttendee.firstName + ' ' + this.currentAttendee.lastName;
       }
        return '';
     },
     nameInitials() {
       let firstName = " ";
       let lastName = " ";
       if (this.attendeeBusinessCard) {
         firstName =  this.attendeeBusinessCard.firstName;
         lastName = this.attendeeBusinessCard.lastName;
       }else if (this.currentAttendee) {
         firstName= this.currentAttendee.firstName;
         lastName= this.currentAttendee.lastName;
       }
       return firstName[0] + lastName[0];
     },
     displayImageUrl() {
       let url = '';
       if (this.attendeeBusinessCard) {
         url = this.attendeeBusinessCard.displayImageUrl;
       } else if (this.currentAttendee) {
         url = this.currentAttendee.displayImageUrl;
       }
       console.log("URL is ", url)
       return url;
     },
     generalInformation() {
        const email = this.attendeeBusinessCard?.email || this.currentAttendee?.email || "-";
        const mobile = this.attendeeBusinessCard?.mobile|| this.currentAttendee?.mobile || '-';
        const businessName = this.attendeeBusinessCard?.businessName || this.currentAttendee?.businessName || "-";
        const jobTitle = this.attendeeBusinessCard?.jobTitle || this.currentAttendee?.jobTitle || '-';
        const country = this.attendeeBusinessCard?.country || this.currentAttendee?.country || '-';

        return {
          email: email,
          mobile: mobile,
          businessName: businessName,
          jobTitle: jobTitle,
          country: country,

        };
     },
     getSelfCategory() {
       if (this.currentAttendee && this.currentAttendee.selfCategories) {
         if (Object.entries(this.currentAttendee.selfCategories).length > 0) {
           return Object.entries(this.currentAttendee.selfCategories).map(([key, value]) => {
             return {
                category: key,
                subcategories: value.join(', ') || "-"
             };
           });
         }
       }
       return [];
     },
     getPreferredCategory() {
       if (this.currentAttendee && this.currentAttendee.preferredCategories) {
         if (Object.entries(this.currentAttendee.preferredCategories).length > 0) {
           return Object.entries(this.currentAttendee.preferredCategories).map(([key, value]) => {
             return {
                category: key,
               subcategories: value.join(', ') || '-'
             };
           });
         }
       }
       return [];
     }
   },
   data() {
     return {
       tab: 0,
       items: [
         {tab: 0, text: 'Attendee Information'},
       ],
       loading: true,
       currentAttendee: null,
       attendeeBusinessCard: null,
       unsubscribeAttendeeSnapshot: null,
       unsubscribeBusinessCardSnapshot: null,
       attendeeId: null,
       currentEventId: null,
       invitationStatus: null,
       generalInformationHeaders:  [
       {
         text: "Email",
         value: "email",
         align: "start",
       },
       {
         text: "Mobile",
         value: "mobile",
         align: "start",
       },
       {
         text: "Business Name",
         value: "businessName",
         align: "start",
       },
       {
         text: "Job Title",
         value: "jobTitle",
         align: "start",
       },
       {
         text: "Country",
         value: "country",
         align: "start",
       }
     ],
       categoryHeaders: [
         {
           text: "Category name",
           value: "category",
           align: "start",
         },
         {
           text: "Sub-categories",
           value: "subcategories",
           align: "start",
         },
       ],
     }
   },
   created() {
     this.currentEventId = this.$route.params.eventId;
     this.attendeeId = this.$route.params.attendeeId;

     this.initialize();
   },

   destroyed() {
     if (this.unsubscribeAttendeeSnapshot) {
       this.unsubscribeAttendeeSnapshot();
     }
     if (this.unsubscribeBusinessCardSnapshot) {
       this.unsubscribeBusinessCardSnapshot();
     }
   },
   methods: {
     ...mapActions(["initializeCurrentEvent"]),
     handleRoute(item) {
       if (!item.disabled) {
         let route = {name: item.routeName, params: item.params};
         if (item.query) {
           route.query = item.query;
         }
         this.$router.push(route);
       }
     },
     async initialize() {
       await this.initializeCurrentEvent(this.currentEventId);
       const attendeeDocId = this.currentEventId + '-' + this.attendeeId;

       this.unsubscribeAttendeeSnapshot = onSnapshot(
           eventAttendeesDocRef(attendeeDocId),
           (querySnapshot) => {
             if (querySnapshot.exists()) {
               this.invitationStatus = 'Joined';
               this.currentAttendee = Attendee.fromObject(querySnapshot.data());
             } else {
               console.log("Doesn't exists");
               const attendeeIndex = this.currentEvent.attendees.findIndex(
                   (attendee) => attendee.attendeeId === this.attendeeId || attendee.uid == this.attendeeId);
               if (attendeeIndex !== -1) {
                 this.invitationStatus = 'Joined';
                 this.currentAttendee = this.currentEvent.attendees[attendeeIndex];
               } else {
                 const inviteeIndex = this.currentEvent.invitees.findIndex(
                     (invitee) => invitee.attendeeId === this.attendeeId);
                  if (inviteeIndex !== -1) {
                    this.invitationStatus = 'Invited';
                    this.currentAttendee = this.currentEvent.invitees[inviteeIndex];
                  } else {
                    this.invitationStatus = 'Pending';
                  }
               }
             }

             if (!this.currentAttendee.businessCardId){
               this.loading = false;
             }
             if (this.currentAttendee && this.currentAttendee.businessCardId && !this.attendeeBusinessCard) {
               this.loadBusinessCard();
             }
           });
     },
      loadBusinessCard() {

        this.unsubscribeBusinessCardSnapshot = onSnapshot(
            businessCardsDocRef(this.currentAttendee.businessCardId),
            (querySnapshot) => {
              this.attendeeBusinessCard = querySnapshot.data();
              if (this.loading) {
                this.loading = false;
              }
            });
      },
   },
 };
</script>